import { useReduxState } from 'hooks';
import { useApiData } from 'lib/api';
import { EmptyIndicator, Owners, TitleWithIcon } from 'components/common';
import { Box, BoxRow } from 'components/common/box';
import { PathsInProductUsers } from '.';

import type { PageState } from 'types';

interface Props {
  guestOnly?: boolean;
  tooltip?: string;
  url: string;
}

const PathsInProduct = ({ guestOnly = false, tooltip, url }: Props) => {
  const { messages } = useReduxState();

  const { data, loading } = useApiData({ url, onlyIf: Boolean(url) });

  return (
    <div className="groups">
      <Box
        headerContent={<PathsInProductUsers paths={data?.paths} url={url} />}
        headerContentWrap={true}
        loading={loading}
        padding={0}
        title={messages.paths}
        titleTooltip={tooltip}
        {...(guestOnly
          ? {
              disabledOverlayContent: messages.coursesGuestsOnlyWarning,
              disabledOverlayIcon: 'exclamation-triangle'
            }
          : {})}
      >
        {data?.paths?.length ? (
          data.paths.map(
            (path: Pick<PageState['path'], 'id' | 'owners' | 'title'>) => (
              <BoxRow key={path.id}>
                <TitleWithIcon
                  icon="tasks"
                  title={path.title}
                  titleLink={{
                    as: `/admin/paths/${path.id}`,
                    href: '/admin/paths/[pathId]'
                  }}
                >
                  <Owners owners={path.owners} />
                </TitleWithIcon>
              </BoxRow>
            )
          )
        ) : (
          <EmptyIndicator
            icon="tasks"
            size="small"
            title={messages.pathsEmpty}
          />
        )}
      </Box>
    </div>
  );
};

export default PathsInProduct;
